import { create } from "zustand";

/**
 * 全域 UI / client 狀態(zustand)。
 *
 * 定位:不是伺服器資料的全域 UI 狀態放這裡(伺服器資料走 react-query,見 hooks/queries)。
 * 例:側欄收合、審核中心待辦徽章數、全站篩選記憶…
 *
 *   const collapsed = useUiStore((s) => s.sidebarCollapsed);
 *   const toggle = useUiStore((s) => s.toggleSidebar);
 *
 * 註:模板既有的 Redux（layout/calendar）維持不動;新模組的 client 狀態用這個。
 *
 * **不要把列表篩選條件放進來**(票 26):那是「以頁為鍵的一袋值」,形狀由各頁自己決定,
 * 放這裡會讓本檔隨頁面數量無限膨脹。它住在 `stores/listFilterStore.js`,
 * 透過 `pages/DCKeeper/useStickyState.js` 使用。
 */
export const useUiStore = create((set) => ({
  // 側欄收合
  sidebarCollapsed: false,
  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
  setSidebar: (collapsed) => set({ sidebarCollapsed: collapsed }),

  // 審核中心待辦徽章(WF 側欄紅色數字)
  approvalPending: 0,
  setApprovalPending: (n) => set({ approvalPending: Math.max(0, Number(n) || 0) }),

  // 全站列表筆數偏好(客戶確認單 Q11:30/60/90)
  pageSize: 30,
  setPageSize: (n) => set({ pageSize: n }),

  // 目前頁面標題 — Figma(18:704)把標題放在 topbar 白卡裡,不是內容區。
  // 由 <PageHeader> 發佈,Header 讀取顯示。
  pageTitle: "",
  setPageTitle: (t) => set({ pageTitle: t }),

  // 返回鍵 — Figma v2(2128:23479)把返回箭頭放在 topbar 標題左邊,
  // 與標題同一個群組(24px icon + gap 10 + 20px Bold 標題),
  // 內容區不再另起一列「← 返回列表」。詳情/表單頁用 usePageTitle(title, onBack) 發佈;
  // 沒有 onBack 的頁面(列表頁)這裡是 null,箭頭就不顯示。
  pageBack: null,
  setPageBack: (fn) => set({ pageBack: fn }),
}));
